<template>
    <main-dialog
        :title="$t('extractText')"
        v-model="isVisible"
        @ok="handleExtract"
        :ok-title="$t('extract')"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
    >
        <div class="extract-text-form">
            <b-form-group :label="$t('inputFile')" label-for="input-file">
                <b-form-input
                    id="input-file"
                    :value="file.name"
                    disabled
                    readonly
                />
            </b-form-group>

            <b-form-group :label="$t('outputFileName')" label-for="output-filename">
                <b-form-input
                    id="output-filename"
                    v-model="outputFileName"
                    :placeholder="$t('enterOutputFileName')"
                />
            </b-form-group>

            <b-form-group>
                <b-form-checkbox v-model="outputText">
                    {{ $t('downloadAsTxt') }}
                </b-form-checkbox>
                <small class="form-text text-muted">{{ $t('downloadAsTxtHint') }}</small>
            </b-form-group>

            <b-form-group v-if="!outputText">
                <b-form-checkbox v-model="saveToLibrary">
                    {{ $t('saveToLibrary') }}
                </b-form-checkbox>
                <small class="form-text text-muted">{{ $t('saveToLibraryHint') }}</small>
            </b-form-group>

            <b-form-group
                v-if="!outputText && saveToLibrary"
                :label="$t('outputPath')"
                label-for="output-path"
            >
                <b-form-input
                    id="output-path"
                    v-model="outputPath"
                    :placeholder="$t('enterOutputPath')"
                />
                <small class="form-text text-muted">{{ $t('outputPathHint') }}</small>
            </b-form-group>
        </div>
    </main-dialog>
</template>

<script>
export default {
    name: 'ExtractTextModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        file: {
            type: Object,
            required: true
        },
        currentPath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            outputFileName: '',
            outputText: false,
            saveToLibrary: true,
            outputPath: ''
        };
    },
    computed: {
        isVisible: {
            get() {
                return this.show;
            },
            set(value) {
                if (!value) {
                    this.$emit('close');
                }
            }
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.initializeForm();
            }
        }
    },
    methods: {
        initializeForm() {
            const baseName = this.file.name.replace(/\.[^/.]+$/, '');
            this.outputFileName = `${baseName}.txt`;
            this.outputPath = this.currentPath;
            this.outputText = false;
            this.saveToLibrary = true;
        },
        handleExtract(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!this.outputFileName) {
                this.$bvToast.toast(this.$t('pleaseEnterOutputFileName'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
                return;
            }

            const options = {
                output_file_name: this.outputFileName,
                output_text: this.outputText
            };

            if (!this.outputText && this.saveToLibrary) {
                options.output_path = this.outputPath;
            }

            this.$emit('extract', options);
            this.isVisible = false;
        }
    }
}
</script>

<style scoped>
.extract-text-form {
    padding: 10px 0;
}
</style>
